import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numberArrayGenerator from 'number-array-generator';
import Helmet from 'react-helmet';
import Dropzone from 'react-dropzone';
import MenuItem from 'material-ui/MenuItem';
import { Link } from 'react-router';
import AutoComplete from 'material-ui/AutoComplete';
import Paper from 'material-ui/Paper';
import AdBlockDetect from 'react-ad-block-detect';
import cookie from 'js-cookie';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { generateFacebookTargetingSpec } from '../../../helpers/facebookAdTargeting';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import TextField from 'material-ui/TextField';
import { Accordion, AdStep2Preview, ButtonBar, FormSection, PageHeader, MultiAccordionSection, SecondaryButton, Spinner } from 'components';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import RaisedButton from 'material-ui/RaisedButton';
import { initLeadAdBuilder, setLeadAdBuilderBullet, uploadFormImage } from 'redux/modules/adBuilder';
import * as styles from './style.scss';
var Intro = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    formValues: state.form["adForm_".concat(orgId)] ? state.form["adForm_".concat(orgId)].values : {},
    theme: state.theme
  };
}, {
  initLeadAdBuilder: initLeadAdBuilder,
  setLeadAdBuilderBullet: setLeadAdBuilderBullet,
  uploadFormImage: uploadFormImage
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Intro, _Component);

  var _super = _createSuper(Intro);

  function Intro() {
    var _this;

    _classCallCheck(this, Intro);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "uploadImage", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(files) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(files && files.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                _this.props.changeField('uploadingImage', true);

                _context2.next = 5;
                return _this.props.asyncChangeField('imageUrl', /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
                    var _yield$client$post, data;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return client.post('/imageUpload', {
                              files: files
                            });

                          case 2:
                            _yield$client$post = _context.sent;
                            data = _yield$client$post.data;
                            return _context.abrupt("return", data.length > 0 ? data[0].fullyQualifiedUrl : null);

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 5:
                _this.props.changeField('uploadingImage', false);

              case 6:
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.error(_context2.t0);

                _this.props.changeField('uploadingImage', false);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(Intro, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var sectionDisabled = this.props.builder ? !this.props.builder.introEnabled : false;
      return /*#__PURE__*/React.createElement("section", {
        style: {
          margin: '1rem'
        }
      }, this.props.validationErrors.length > 0 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 50
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "There are errors in this section.")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("ul", null, this.props.validationErrors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            color: 'red'
          }
        }, e);
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Headline"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-9"
      }, this.props.builder && /*#__PURE__*/React.createElement(TextField, {
        hintText: "Briefly describe what people will receive (Required)",
        value: this.props.builder.introHeadline,
        disabled: sectionDisabled,
        fullWidth: true,
        onChange: function onChange(_ref3) {
          var target = _ref3.target;
          return _this2.props.changeField('introHeadline', target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-1"
      }, 60 - (this.props.builder ? this.props.builder.introHeadline.length : 0))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 16
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Image"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: "imageType",
        defaultSelected: "fromAd",
        valueSelected: (this.props, this.props.builder.introImageType),
        onChange: function onChange(e, val) {
          if (val === 'uploaded') {
            console.log('SHOW UPLOAD FORM');
          }

          _this2.props.changeField('introImageType', val);
        }
      }, /*#__PURE__*/React.createElement(RadioButton, {
        disabled: sectionDisabled,
        value: "fromAd",
        label: "Use the image from your ad"
      }), /*#__PURE__*/React.createElement(RadioButton, {
        disabled: sectionDisabled,
        value: "uploaded",
        label: "Use uploaded image"
      }))), this.props.builder && this.props.builder.introImageType === 'uploaded' && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-xs-offset-3"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("small", null, "Recommended image size: 1200 x 628 pixels.")), this.props.builder.uploadingImage ? /*#__PURE__*/React.createElement("div", {
        style: {
          height: 75,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, this.props.builder.imageUrl === 'http://bit.ly/2k0Ds2T' && /*#__PURE__*/React.createElement(Dropzone, {
        onDrop: this.uploadImage,
        accept: 'image/*',
        style: {
          width: 120,
          height: 120,
          borderColor: '#8b8b8b',
          borderRadius: 4,
          border: '1px dashed #8b8b8b'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          position: 'relative',
          top: '25%',
          color: '#8b8b8b',
          fontSize: 13,
          padding: 8
        }
      }, "Drag and drop an image here or click to upload.")), this.props.builder.imageUrl && this.props.builder.imageUrl !== 'http://bit.ly/2k0Ds2T' && /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 16,
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center',
          backgroundColor: '#fff',
          borderWidth: 1,
          borderColor: '#8b8b8b',
          borderStyle: 'solid',
          position: 'absolute',
          top: '-10px',
          left: '-10px',
          width: 25,
          height: 25,
          lineHeight: '25px',
          borderRadius: '50%',
          display: 'inline-block',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          _this2.props.changeField('imageUrl', 'http://bit.ly/2k0Ds2T');
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-close-empty",
        style: {
          color: '#8b8b8b',
          fontSize: 25,
          lineHeight: '24px',
          width: '100%',
          display: 'inline-block',
          textAlign: 'center'
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: "url(".concat(this.props.builder.imageUrl, ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          display: 'inline-block',
          marginRight: 16,
          width: 120,
          height: 120,
          cursor: 'pointer',
          borderColor: '#DBDBDB',
          borderWidth: '0.5px',
          borderStyle: 'solid',
          borderRadius: '4px'
        }
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 30
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-2 ".concat(styles.textFieldLabel)
      }, "Layout"), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10"
      }, this.props.builder && /*#__PURE__*/React.createElement(DropDownMenu, {
        disabled: sectionDisabled,
        value: this.props.builder.introLayoutType === 0 ? 'paragraph' : 'bullets',
        onChange: function onChange(idx, key) {
          _this2.props.changeField('introLayoutType', key);
        },
        fullWidth: true
      }, /*#__PURE__*/React.createElement(MenuItem, {
        value: 'paragraph',
        primaryText: 'Paragraph'
      }), /*#__PURE__*/React.createElement(MenuItem, {
        value: 'bullets',
        primaryText: 'Bullets'
      })))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-10 col-xs-offset-2"
      }, this.props.builder && /*#__PURE__*/React.createElement("div", null, this.props.builder.introLayoutType === 0 ? /*#__PURE__*/React.createElement(TextField, {
        disabled: sectionDisabled,
        hintText: "Enter text that tells people about your product or service (Required)",
        multiLine: true,
        rows: 3,
        rowsMax: 6,
        fullWidth: true,
        value: this.props.builder.introParagraph,
        onChange: function onChange(e, val) {
          return _this2.props.changeField('introParagraph', val);
        }
      }) : this.props.builder.introBullets.map(function (val, idx) {
        return /*#__PURE__*/React.createElement("div", {
          className: "row",
          key: idx
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xs-11"
        }, _this2.props.builder && /*#__PURE__*/React.createElement(TextField, {
          disabled: sectionDisabled,
          hintText: idx === 0 ? 'Enter text that tells people about your product or service (Required)' : undefined,
          value: val,
          fullWidth: true,
          id: "introBullets_".concat(idx),
          onChange: function onChange(_ref4) {
            var target = _ref4.target;
            return _this2.props.changeField("introBullets[".concat(idx, "]"), target.value);
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "col-xs-1"
        }, 80 - val.length));
      })))));
    }
  }]);

  return Intro;
}(Component)) || _class);
export default Intro;